import style from "./Flex.module.css";
import clsx from "classnames";
import { cloneElement, Children } from "react";
import React from "react";

function HorizontalFlex(props) {

  const childrenWithProps = Children.map(props.children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { parentClass:"horizontal", flexStart: props.flexStart?props.flexStart:null  });
    }
    return child;
  });
  return (
    <div
      className={
        props.flexStart
          ? clsx(style.horizontal, style.flexStart)
          : clsx(style.flex, style.horizontal)
      }
      style={
        {
          maxWidth: (props.maxWidth ? props.maxWidth : null),
          width: (props.width ? props.width : null),
          height: (props.height ? props.height : null),
          overflow: (props.overflow ? props.overflow : null),
          padding: (props.padding ? props.padding : null),
          overflowX: (props.overflowX ? props.overflowX : props.overflow),
          overflowY: (props.overflowY ? props.overflowY : props.overflow),
          gap: (props.gap ? props.gap : null),
          backgroundColor: (props.backgroundColor ? props.backgroundColor : null),
          alignItems: (props.alignItems ? props.alignItems : props.flexStart?"flex-start":"center"),
          justifyContent: (props.justifyContent ? props.justifyContent : null)
        }
      }
    >
      {childrenWithProps}
    </div>
  );
}

export default HorizontalFlex;
